import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  root: {
    position: 'absolute',
    left: 0,
    top: 60,
    width: '100%',
    border: '1px solid #cfd8dc',
    backgroundColor: '#fff',
    boxShadow: '1px 2px 6px rgba(0,0,0,0.15)',
    fontSize: 12,
    zIndex: 99,
  },
  ulRoot: {
    paddingBottom: 30,
    maxHeight: 200,
    overflowY: 'auto',
    paddingRight: 25,
  },
  pRoot: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '100%',
    backgroundColor: '#eee',
    color: '#999',
    paddingLeft:10,
    paddingRight: 25,
    lineHeight: '26px',
  },
  liRoot: {
    paddingLeft:10,

    lineHeight: '26px',
  },
  closeIcon: {
    position: 'absolute',
    right: 10,
    top: 10,
    fontSize: 14,
    zIndex: 99,
  },
};

class Matching extends Component {

  constructor(props) {
    super(props);
    this.total = this.props.total;
    this.list = this.props.list;
    this.choose = this.choose.bind(this);
    this.clear = this.clear.bind(this);
  }

  init() {

  }

  componentDidMount() {
    this.init();
  }

  clear() {
    if ( typeof this.props.onChange === 'function' ) {
      this.props.onChange();
    }
  }

  choose(item) {
    if ( typeof this.props.onChange === 'function' ) {
      this.props.onChange(item);
    }
  }


  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <ul className={classes.ulRoot}>
          {
          this.list.map((item, index) =>
            <li key={index} onClick={() => this.choose(item)}  className={classes.liRoot}>
              {item.companyName}
            </li>
          )}
        </ul>
        <p className={classes.pRoot}>为您找到相关结果 {this.total} 个</p>
      <CloseIcon className={classes.closeIcon} onClick={() => this.clear()} />
      </div>
    );
  }
}

Matching.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Matching);
